import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { StatesState } from "types/State";

const initialState: StatesState = {
  states: [],
  counties: [],
  cities: [],
  geolocation: { longitude: 0, latitude: 0 },
};

export const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers,
});

export const { setStates, setCities, setCounties, setGeolocation } =
  stateSlice.actions;

export default stateSlice.reducer;
